module.exports = __webpack_public_path__ + "media/images/img_service_7-fb48f4f4410fedc8537bd797995d8f07.png";